
import DomainService from "@/services/DomainService";
import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      domain: "",
      locationId: "",
      destinationLocationId: "",
      errorMessage: "",
      successMessage: "",
      domainError: "",
      locationIdError: "",
      destinationLocationIdError: "",
      isLoading: false,
    };
  },
  methods: {
    async transferDomain() {
      this.clearErrors();
      if (!this.domain) {
        this.domainError = "Domain is required.";
      }
      if (!this.locationId) {
        this.locationIdError = "Location ID is required.";
      }
      if (!this.destinationLocationId) {
        this.destinationLocationIdError = "Destination Location ID is required.";
      }
      if (this.domainError || this.locationIdError || this.destinationLocationIdError) {
        this.errorMessage = "Please fix the errors above";
        this.errorMessage = this.errorMessage;
        return;
      }
      try {
        this.isLoading = true;
        this.errorMessage = "";
        // call the transferDomain service
        console.log("Transfer domain", this.domain, this.locationId, this.destinationLocationId);

        await DomainService.transferDomain({
          domain: this.domain,
          locationId: this.locationId,
          targetLocationId: this.destinationLocationId,
        });

        this.successMessage = "Domain transferred successfully.";

        this.resetState();
      } catch (error: any) {
        this.errorMessage =
          error?.response?.data?.message || "An error occurred during the transfer.";
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    resetState() {
      this.domain = "";
      this.locationId = "";
      this.destinationLocationId = "";
      this.errorMessage = "";
      this.domainError = "";
      this.locationIdError = "";
      this.destinationLocationIdError = "";
    },
    clearErrors() {
      this.domainError = "";
      this.locationIdError = "";
      this.destinationLocationIdError = "";
      this.errorMessage = "";
      this.successMessage = "";
    },
  },
});
